import { useEffect, useState } from "react";
import { useGlobalReducer } from "../../GlobalContext";
import { PicklistOption } from "../blocks/fields/PicklistField.types";
import { adaptPortalUsers } from "../config/formViewStorage";

const NoOptions: PicklistOption[] = [];

// Held for the session, as the lookup records are.
let cached: PicklistOption[] | undefined;

/** The people who can sign in to the portal, each picked by lower-cased email address. */
export function usePortalUserOptions(enabled: boolean) {
  const globalDispatch = useGlobalReducer();
  const [options, setOptions] = useState<PicklistOption[]>(cached ?? NoOptions);

  useEffect(() => {
    if (!enabled || cached) {
      return undefined;
    }

    let cancelled = false;

    // Loaded on first read, so rendering a filter bar doesn't pull the service into
    // every page-component test.
    import("../api/appService")
      .then(({ GetPortalUsers }) => GetPortalUsers(globalDispatch))
      .then((response: { data?: unknown }) => {
        cached = adaptPortalUsers(response?.data)
          .filter((user) => user.emailAddress)
          .map((user) => ({ Key: user.emailAddress, Value: user.emailAddress }))
          .sort((a, b) => a.Value.localeCompare(b.Value));

        if (!cancelled) {
          setOptions(cached);
        }
      })
      .catch(() => {
        // The service has already said so; an empty dropdown is the failure.
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, globalDispatch]);

  return options;
}
